import React from 'react';
import { Star } from 'lucide-react';
import defaultTipsterImage from '../../assets/icons/ic_tipster_default.svg';

interface TipsterProfileCardProps {
  userImg: string;
  username: string;
}

export const TipsterProfileCard: React.FC<TipsterProfileCardProps> = ({
  userImg,
  username,
}) => {
  return (
    <div className="flex items-center gap-3 px-3">
      <div className="relative">
        <img
          src={userImg || defaultTipsterImage}
          className="h-12 w-12 rounded-full object-cover ring-2 ring-[#6633ff]/50"
          alt="user profile pic"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <div className="truncate text-sm font-semibold text-white">
            {username}
          </div>
        </div>
      </div>
    </div>
  );
};
